<script>
import { mapState, mapActions } from 'vuex';
import productTypeIds from '../../variables/productTypeIds';
import TwTitleBar from '../../components/TwTitleBar';

export default {
  name: 'ItineraryPricesWrapper',
  components: {
    TwTitleBar,
  },
  data() {
    return {
      breadcrumbs: [
        { text: this.$t('menu.itinerary.title'), to: '', disabled: true },
        { text: this.$t(`breadcrumbs.${this.$route.name}`), to: this.$route.path },
      ],
    };
  },
  created() {
    this.getDomainsByProductTypeId(productTypeIds.ELCANO_MASTER);
    this.getItinerary(this.$route.params.id);
  },
  computed: {
    ...mapState({
      availableDomains: state => state.app.domains.items,
      currentItinerary: state => state.itinerary.edit.item,
    }),
  },
  methods: {
    ...mapActions({
      getDomainsByProductTypeId: 'app/getDomainsByProductTypeId',
      getItinerary: 'itinerary/getItinerary',
    }),
    createPath(domainId) {
      return `/itinerary/prices/${this.$route.params.id}/${domainId}`;
    },
  },
};
</script>

<template>
  <v-content>
    <tw-title-bar
      :title="$t('menu.itinerary.priceinterval.title')"
      :breadcrumbs="breadcrumbs"
    >
    </tw-title-bar>
    <div class="pa-2">
      <h2 class="mb-2 ml-3" v-if="currentItinerary">{{ currentItinerary.name }}</h2>
      <v-card>
        <v-tabs fixed-tabs class="pb-3">
          <v-tab
            v-for="domain in availableDomains"
            :key="domain.id"
            :to="createPath(domain.id)"
            :value="domain.id"
          >
            {{ domain.shortName }}
          </v-tab>
        </v-tabs>
      </v-card>
      <router-view />
    </div>
  </v-content>
</template>



// WEBPACK FOOTER //
// src/pages/itinerary/ItineraryPricesRoutingWrapper.vue